/** What the floating AI dialogs (recording, assistant) say when they block switching patients. */
export const AI_DIALOG_LOCK_MESSAGE =
  'You cannot perform this action while the AI processing dialog is active. Please close or finish your current AI processing first.';

/**
 * Who is holding the current patient in place. Each holder takes the lock with an optional reason and lets it go
 * when done; the most recent reason still held is what the user is told. A holder without a reason is an AI dialog,
 * which is brought back into view when someone tries to leave.
 */
export class PatientNavigationLock {
  private holders: (string | null)[] = [];

  get locked(): boolean {
    return this.holders.length > 0;
  }

  acquire(reason?: string): void {
    this.holders.push(reason ?? null);
  }

  release(reason?: string): void {
    const i = this.holders.lastIndexOf(reason ?? null);
    if (i >= 0) this.holders.splice(i, 1);
  }

  /** The message to show when navigation is blocked, and whether to bring the AI dialog back. */
  blocked(): { message: string; restoreAiDialog: boolean } {
    const reason = this.holders.length ? this.holders[this.holders.length - 1] : null;
    return reason ? { message: reason, restoreAiDialog: false } : { message: AI_DIALOG_LOCK_MESSAGE, restoreAiDialog: true };
  }
}
